<div class="relative h-full">
  @if (isSeries(seriesItem)) {
  <header class="bg-white dark:bg-black-dark mb-2">
    <div class="flex justify-between items-center pr-0 h-[38px] mb-3">
      <h2
        class="!mt-0 !mb-0 !ml-0 max-sm:!max-w-[60%] max-mobile:pl-5 max-mobile:pr-0"
      >
        {{ "MY_VIEWING_DATES" | translate }}
      </h2>
      <button class="btn btn-small" (click)="saveAllDates()">
        {{ submitText }}
      </button>
    </div>
    <div
      class="tabs-container pb-2 mb-3 max-mobile:mt-4 overflow-x-auto whitespace-nowrap border-b border-borders-light dark:border-borders-darker"
    >
      <div class="tabs">
        @for (season of seriesItem.seasons; track trackBySeason($index, season))
        { @if ( getLatestEpisodeViewed()?.seasonNumber && season.seasonNumber <=
        getLatestEpisodeViewed()!.seasonNumber ) {
        <button
          class="btn btn-small capitalize"
          [ngClass]="{active: activeTab === season.seasonNumber}"
          (click)="displayTab($event, season.seasonNumber)"
          (keyup)="onKeyUp($event, 'displayTab', season.seasonNumber)"
          tabindex="0"
        >
          {{ "SEASON" | translate }} {{ season.seasonNumber }}
        </button>
        } }
      </div>
    </div>
  </header>
  @if (seriesItem.seasons) { @for (season of seriesItem.seasons; track
  trackBySeason($index, season)) {
  <div
    class="hidden overflow-y-scroll max-h-[calc(100vh-(var(--sab)+var(--sat))-190px)] mobile:max-h-[380px] max-mobile:mt-3"
    [ngClass]="{'!block': season.seasonNumber === activeTab}"
  >
    @for ( episode of season.episodes; track trackByEpisode(i, episode); let i =
    $index) {
    <div class="mb-3 pr-2">
      @if ( (getLatestEpisodeViewed()?.seasonNumber && season.seasonNumber <
      getLatestEpisodeViewed()!.seasonNumber) ||
      (getLatestEpisodeViewed()?.seasonNumber && season.seasonNumber ===
      getLatestEpisodeViewed()!.seasonNumber &&
      getLatestEpisodeViewed()?.episodeNumber && i + 1 <=
      getLatestEpisodeViewed()!.episodeNumber) ) {
      <div>
        <span class="font-bold"
          >{{ "EPISODE" | translate }} {{ episode.number }}</span
        >
        @if (getEpisodeTranslation(episode, 'title')) { :
        {{ getEpisodeTranslation(episode, "title") }}
        }
      </div>
      <app-edit-work-completion-dates
        [item]="seriesItem"
        [season]="season"
        [episode]="episode"
        [episodeNumber]="i + 1"
        (dateChange)="handleDateChange($event)"
      ></app-edit-work-completion-dates>
      }
    </div>
    }
  </div>
  } } @else {
  <div class="absolute inset-y-2/4 -translate-y-2/4 left-1/2 -translate-x-2/4">
    <img
      src="./assets/images/loading.svg"
      alt="{{ 'LOADING' | translate }}"
      class="block w-[102px] h-[102px]"
    />
  </div>
  } }
</div>
